export const UNREGISTERED_MOTO = {
  isHidden: true,
  nickname: 'PRODUCTS.UNREGISTERED_MOTO.nickname',
};
